import React, { useState } from "react";
import { FaPlus, FaChevronDown } from "react-icons/fa";
import "./AccordionItem.css";

const AccordionItem = ({ title, content }) => {
  const [isActive, setIsActive] = useState(false);

  const handleToggle = () => {
    setIsActive((prev) => !prev);
  };

  return (
    <div className="accordion-item1">
      <div className="accordion-header1" onClick={handleToggle}>
        <p className="accordion-title-text1">{title}</p>
        {isActive ? (
          <FaChevronDown className="accordion-icon1 open" size={16} />
        ) : (
          <FaPlus className="accordion-icon1" size={16} />
        )}
      </div>
      <div className={`accordion-body1 ${isActive ? "show" : ""}`}>
        {content}
      </div>
    </div>
  );
};

export default AccordionItem;
